import gql from "graphql-tag";

export default gql`
  mutation RecordDataQualityDecision($input: DataQualityDecisionInput!) {
    recordDataQualityDecision(input: $input) {
      tenantId
      objectId
      environment
      version
    }
  }
`;
